import { displayMarineValue } from '../../../utils/marineForecast.utils';
import { getMarineWidgetLayout } from '../../../utils/marineForecastWidget.utils';

export const getSurfAlertsWidgetLayout = getMarineWidgetLayout;

export const getSurfAlertsWidgetSegmentEntries = (dayGroup) =>
  dayGroup?.marineData?.filter(Boolean) ?? [];

export const getSurfAlertsWidgetTileValue = (entry) =>
  displayMarineValue(entry?.surf, 'No surf alert');

export const getSurfAlertsWidgetTileAriaLabel = (entry) => {
  const segment = displayMarineValue(entry?.day_segment, 'selected period');
  const surfAlert = displayMarineValue(entry?.surf, 'surf alert unavailable');
  const wave = displayMarineValue(entry?.wave, 'wave conditions unavailable');
  const wind = displayMarineValue(entry?.wind, 'wind conditions unavailable');

  return `Select ${segment} surf forecast, ${surfAlert}, wave ${wave}, wind ${wind}`;
};
